/**
 * Returns the object type of the given value.
 */
export function getType(value) {
  return Object.prototype.toString.call(value);
}
/**
 * Returns whether the given value is undefined.
 */

export function isUndefined(value) {
  return typeof value === 'undefined';
}
/**
 * Returns whether the given value is null.
 */

export function isNull(value) {
  return value === null;
}
/**
 * Returns whether the given value is null or undefined.
 */

export function isNil(value) {
  return isUndefined(value) || isNull(value);
}
/**
 * Returns whether the given value is not null or undefined.
 */

export function isNotNil(value) {
  return !isNil(value);
}
/**
 * Returns whether the given value is a boolean.
 */

export function isBoolean(value) {
  return typeof value === 'boolean';
}
/**
 * Returns whether the given value is a string.
 */

export function isString(value) {
  return typeof value === 'string';
}
/**
 * Returns whether the given value is a number, excluding NaN values.
 */

export function isNumber(value) {
  return typeof value === 'number' && !Number.isNaN(value);
}
/**
 * Returns whether the given value is a date.
 */

export function isDate(value) {
  return getType(value) === '[object Date]';
}
/**
 * Returns whether the given value is any kind of object, including special
 * classes or objects with different prototypes.
 */

export function isObject(value) {
  return getType(value) === '[object Object]';
}
/**
 * Returns whether the given value is a plain object, excluding special classes
 * or objects with different prototypes.
 */

export function isPlainObject(value) {
  return isObject(value) && value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
/**
 * Returns whether the given value is a regular expression.
 */

export function isRegExp(value) {
  return getType(value) === '[object RegExp]';
}
/**
 * Returns whether the given value is a function.
 */

export function isFunction(value) {
  var isAlert = typeof window !== 'undefined' && value === window.alert;
  if (isAlert) return true;
  var type = getType(value);
  return type === '[object Function]' || type === '[object GeneratorFunction]' || type === '[object AsyncFunction]';
}
/**
 * Returns whether the given value is an array.
 */

export function isArray(value) {
  return isFunction(Array.isArray) ? Array.isArray(value) : getType(value) === '[object Array]';
}
/**
 * Returns whether the given value is an argument object.
 */

export function isArguments(value) {
  return getType(value) === '[object Arguments]';
}
/**
 * Returns whether the given value is an error object.
 */

export function isError(value) {
  return getType(value) === '[object Error]';
}
/**
 * Returns whether the given value is an empty string
 */

export function isEmptyString(value) {
  return isString(value) && value.length === 0;
}
/**
 * Returns whether the given value is an empty array
 */

export function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}
/**
 * Returns whether the given value is an empty plain object
 */

export function isEmptyPlainObject(value) {
  return isPlainObject(value) && Object.keys(value).length === 0;
}
/**
 * Returns whether the given value is empty.
 */

export function isEmpty(value) {
  if (isString(value) || isArray(value) || isArguments(value)) return value.length === 0;
  if (isPlainObject(value)) return Object.keys(value).length === 0;
  return !value;
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/task-queue/~/@flowio/is/lib/esm/index.js
// module id = 700
// module chunks = 0 1